import useSupportProfile from "../../hooks/useSupportProfile";
import isSupportAccount from "../../utils/isSupportAccount";

export default function IfSupport({ children }) {
  const supportProfile = useSupportProfile();
  return isSupportAccount(supportProfile) ? children : null;
}
